/** Lowercase slug for certificate product `targetType` (1–64 chars). */
export const CERTIFICATE_PRODUCT_TARGET_SLUG_PATTERN = /^[a-z][a-z0-9_]{0,63}$/;

export function isValidCertificateProductTargetSlug(raw: string): boolean {
  const t = raw.trim();
  return t.length >= 1 && t.length <= 64 && CERTIFICATE_PRODUCT_TARGET_SLUG_PATTERN.test(t);
}
